import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import htlt1 from "../../img/HT LT AVR/htlt1.jpg"
import htlt2 from "../../img/HT LT AVR/htlt2.jpg"

function HTLTAVR() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="ht-lt-avr">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">⚡ HT & LT Automatic Voltage Regulator (AVR)</h2>
              <p className="text-muted">
                Stabilize voltage levels for sensitive equipment with high-efficiency automatic voltage regulation.
              </p>
              <p className="text-muted fw-semibold">AVR PANEL &nbsp; | &nbsp; High & Low Voltage Regulation</p>
            </div>

            {/* Application */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                HT & LT AVRs are used to maintain constant voltage levels by regulating fluctuations in input supply, ensuring stable power for sensitive electrical equipment. Commonly used in industries, commercial complexes, hospitals, data centers, and infrastructure projects for both high and low voltage applications.
              </p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={htlt1}
                  alt="HT AVR"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={htlt2}
                  alt="LT AVR"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
            
              <h6 className="fw-semibold">🔹 LT AVR</h6>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 415V ± 20% input</li>
                <li><strong>Capacity:</strong> 10 kVA to 6300 kVA</li>
                <li><strong>Correction Speed:</strong> 10–35 V/sec</li>
                <li><strong>Phase:</strong> Single & Three-phase</li>
              </ul>

              <h6 className="fw-semibold mt-3">🔹 HT AVR</h6>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 11kV / 22kV / 33kV ± 20%</li>
                <li><strong>Capacity:</strong> 100 kVA to 10 MVA</li>
                <li><strong>Correction Speed:</strong> 1–2 sec per %</li>
                <li><strong>Cooling:</strong> ONAN / ONAF</li>
                <li><strong>Phase:</strong> Single & Three-phase</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Maintains stable output voltage despite input fluctuations</li>
                <li>Microcontroller-based control with digital display</li>
                <li>Automatic & manual operation modes</li>
                <li>Built-in protections: overload, short circuit, under/overvoltage</li>
                <li>Silent and energy-efficient operation</li>
                <li>Optional remote monitoring (SCADA/IoT)</li>
                <li>High efficiency (above 98%) with fast response time</li>
                <li>Oil-cooled (HT) and air-cooled (LT) models available</li>
              </ul>
            </div>

            {/* CTA */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need Voltage Regulation Solutions?</h5>
              <p className="mb-2 text-muted">
                Contact us for customized HT or LT AVR systems tailored to your application.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default HTLTAVR;
